<div class="assistentes-popup">
    <h2 class="m-b-5" mat-dialog-title>Asistentes</h2>
    <div mat-dialog-content>
        <form >
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="50px">
                <div class="widget mr-20 mt-4" fxFlex.gt-sm="100">
                    <mat-form-field class="full-width">
                      <mat-label>Personas de contacto</mat-label>
                      <mat-select multiple [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="selectedContact" 
                      (ngModelChange)="selectedContact"
                      class="full-width-multi-select" >
                        <mat-option *ngFor="let contact of contactList" [value]="contact.id"> {{contact.nombre}}</mat-option>
                        
                      </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="isError"
                    class="error-space">
                    <span>Obligatorio</span>
                   </mat-error>
                  </div>
            </div>
        </form>
    </div>

    <div class="text-a-r  m-t-10 m-b-10">
        <button (click)="guadar()" mat-raised-button color="accent"  class="m-r-15">Guardar</button>
        <button (click)="cancel()" mat-raised-button  color="warn">Cancelar</button>
    </div>
</div>